import { Component, AfterContentChecked } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService, HttpClientService } from './../../../lib/ng2-sapmp/src/providers';
import { KEY_CONFIG } from './../../../lib/ng2-sapmp/src/config/key-config';
import { NotificationAlertComponent } from './../notifications/notification.component';
import { NotificationService } from './../notifications/shared/notification.service';

declare var ENV_PORTAL: any;

@Component({
  selector: 'app-alert-banner',
  templateUrl: './alert-banner.component.html',
  styleUrls: ['./alert-banner.component.scss'],
  providers: [NotificationService]
})
export class AlertBannerComponent implements AfterContentChecked {
  public notification: NotificationAlertComponent;
  public newAlerts: any;
  public alerts: any;
  public adminPortal: boolean = false;  

  // public newAlerts: number;

  constructor(private util: UtilityService, private httpService: HttpClientService, private notificationService: NotificationService) { 
    if (ENV_PORTAL === "dmpadmin" ) {
      this.adminPortal = true;
    }
  }
  ngAfterContentChecked() {
    if (sessionStorage.getItem('user') && !this.newAlerts &&
      !sessionStorage.getItem('once') && (JSON.parse(sessionStorage.getItem('user')).user.addpAuthority !== 'NONE')) {
      sessionStorage.setItem('once', 'true');
      if(!this.adminPortal) {
      this.notificationService.getAlerts().subscribe(resObj => {
        this.newAlerts = resObj.alerts.length;
      }, error => {
        this.newAlerts = 0;
        console.log('error loading alerts ' + error);
      });
    }
  }
  }

  dismissInfo(event) {
    if (event.keyCode !== KEY_CONFIG.tabKey) {
      this.removeNotifications();
    }
  }

  showAlerts(event) {
    if (event.keyCode !== KEY_CONFIG.tabKey || !event.keyCode) {
      let custElement = <CustomEventInit> document.getElementById('alert-nav');
      var evt = new CustomEvent("toggleAlertMenu", custElement);
      document.dispatchEvent(evt);

      this.removeNotifications();
    }
  }

  removeNotifications() {
    this.newAlerts = 0;
    sessionStorage.removeItem('newNotifications');
  }
}
